import { type ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { LottiePlayer } from '@repo/design-system-kit/components/lottie-player/lottie-player';
import loginLottie from '@repo/visual-assets/dotlottie/lottie_split_general_login.lottie';
import { RegistrationLayout } from '../layouts/registration/registration-layout';
import { LoginForm } from '../login-form';
import styles from './login-page.module.css';

interface LoginPageProps {
  authenticate: (email: string, password: string) => Promise<void>;
  onForgotPasswordClick: () => void;
  showAside: boolean;
}

export function LoginPage({
  authenticate,
  onForgotPasswordClick,
  showAside,
}: LoginPageProps): ReactNode {
  const { formatMessage } = useIntl();
  return (
    <RegistrationLayout
      aside={
        showAside ? (
          <LottiePlayer className={styles.lottie} data-test-login-lottie src={loginLottie} />
        ) : null
      }
    >
      <h1 className="heading-section mb-32" data-test-login-title>
        {formatMessage({ id: 'sign-in.title' })}
      </h1>
      <LoginForm authenticate={authenticate} onForgotPasswordClick={onForgotPasswordClick} />
    </RegistrationLayout>
  );
}
